module.exports = __webpack_public_path__ + "static/media/round-green-rect.6178d137.webp";